import Hero from "../components/Hero";
import BookCar from "../components/BookCar";
import React, { useState, useEffect } from 'react';
import PickCar from "../components/PickCar";
import Banner from "../components/Banner";
import Bannerz from "../components/clientbanner";
import ChooseUs from "../components/ChooseUs";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
//import Models from "./Models";
import { Helmet } from "react-helmet";
import Options from "../components/Option";
import Atvbanner from "../components/atvbanner";
import Atvbanner2 from "../components/atvbanner2";
import Loader from "./Loader";
import PickCeleb from "../components/PickCeleb";


function Home() {

  const [showDelayedComponents, setShowDelayedComponents] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowDelayedComponents(true);
    }, 11000);

    return () => clearTimeout(timer); // Cleanup the timer on component unmount
  }, []);



  return (
    <>
      <Helmet>
        <title>
        Home - Price is Right ATV
        </title>

        <meta
          name="description"
          content="Contact Price Is Right ATV in Leeward Palms, Turks & Caicos Islands, for ATV rentals, jet ski bookings, and drone photo shoots. Reach out to plan your ultimate island adventure today!"
        />
        {/* Add more meta tags as needed */}
      </Helmet>


      <Loader />
      <Hero />
      {/* 
      <PickCar />
      <PickCeleb/>  */}
      
      <Options/>
      <ChooseUs />

      {showDelayedComponents && (
         <>
      <Atvbanner2/>
      <Atvbanner/>
    {/* <Bannerz/>
 */}  
      <Testimonials />
      

      <Banner />
      <Faq />
      <Footer />
      </>
    )}
      
    </>
  );
}

export default Home;
